import { PetOwnerEffects } from './consultation-pet-owner.effects';
import { ConsultationCreateEffects } from './consultation-create.effects';

export const ConsultationEffects = [ConsultationCreateEffects, PetOwnerEffects];
